import { render, staticRenderFns } from "./serve.vue?vue&type=template&id=3d30facd&scoped=true&"
import script from "./serve.vue?vue&type=script&lang=js&"
export * from "./serve.vue?vue&type=script&lang=js&"
import style0 from "./serve.vue?vue&type=style&index=0&id=3d30facd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d30facd",
  null
  
)

export default component.exports